import { HtmlParser } from '@calendly/html-parser';
import { Link } from '@calendly/ui/components/link';
import classNames from 'classnames';
import { useCallback, useState, forwardRef } from 'react';
import { AuthPopUp } from './auth_popup';
const errorMessageCss = "e1bsescw";
const ErrorMessage = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(errorMessageCss, props.className)} />;
});
export const ICloudFormError = ({
  error
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const onClose = () => setIsOpen(false);
  const ErrorMessageLink = useCallback(children => <Link as="button" onClick={() => setIsOpen(true)} {...children} />, []);
  if (!error) return null;
  return <>
      <ErrorMessage>
        {HtmlParser(error, {
        ErrorMessageLink
      })}
      </ErrorMessage>
      {isOpen && <AuthPopUp isOpen onClose={onClose} />}
    </>;
};

require("./icloud_form_error.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./icloud_form_error.js");